<template>
    <Breadcrumbs main="Icons" title="ICO Icon" />
    <div class="container-fluid ">
        <div class="row">
            <abstractIcon @selected="icon_bar" />
            <animalIcon @selected="icon_bar" />
            <brandIcons @selected="icon_bar" />
            <Business @selected="icon_bar" />
            <Chart @selected="icon_bar" />
            <Construction @selected="icon_bar" />
            <Currency @selected="icon_bar" />
            <Device @selected="icon_bar" />
            <Directional @selected="icon_bar" />
            <Education @selected="icon_bar" />
            <Emoticon @selected="icon_bar" />
            <Filetype @selected="icon_bar" />
            <Food @selected="icon_bar" />
            <Kids @selected="icon_bar" />
            <Law @selected="icon_bar" />
            <Mathematical @selected="icon_bar" />
            <Medical @selected="icon_bar" />
            <Mobile @selected="icon_bar" />
            <Multimedia @selected="icon_bar" />
            <Payment @selected="icon_bar" />
            <Person @selected="icon_bar" />
            <Search @selected="icon_bar" />
            <Social @selected="icon_bar" />
            <Sport @selected="icon_bar" />
            <Text @selected="icon_bar" />
            <Transport @selected="icon_bar" />
            <Travel @selected="icon_bar" />
            <Weather @selected="icon_bar" />
            <Web @selected="icon_bar" />
        </div>
    </div>
    <div class="icon-hover-bottom p-fixed fa-fa-icon-show-div" :class="{ 'opecity-0': !icon_bar_status }"
        :style="[icon_bar_status ? { 'display': 'block' } : { 'display': 'none' }]">
        <div class="container-fluid">
            <div class="row">
                <div class="icon-popup">
                    <div class="close-icon" v-on:click="close_icon_bar"><i class="icofont icofont-close"></i></div>
                    <div class="icon-first"><i class="fa-2x" :class="[select_icon.class]"></i></div>
                    <div class="icon-class">
                        <label class="icon-title">Class</label><span>icon-drupal</span>
                    </div>
                    <div class="icon-last icon-last">
                        <label class="icon-title">Markup</label>
                        <div class="form-inline">
                            <div class="form-group">
                                <input class="inp-val form-control m-r-10" type="text" ref="text" :value="select_icon.tag">
                                <button class="btn btn-primary notification" v-on:click="copy_icon">Copy text</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
import { icon_bar_status, select_icon, } from "@/composables/flagIcon"
const abstractIcon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/abstractIcon.vue"))
const animalIcon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/animalIcon.vue"))
const brandIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/brandIcons.vue"))
const Business = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/businessIcons.vue"))
const Chart = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/chartIcons.vue"))
const Construction = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/constructionIcons.vue"))
const Currency = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/currencyIcons.vue"))
const Device = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/deviceIcons.vue"))
const Directional = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/directionalIcons.vue"))
const Education = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/educationIcons.vue"))
const Filetype = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/filetypeIcons.vue"))
const Emoticon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/emoticonIcons.vue"))
const Food = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/foodIcons.vue"))
const Kids = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/kidsIcons.vue"))
const Law = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/lawIcons.vue"))
const Mathematical = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/mathematicalIcons.vue"))
const Medical = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/medicalIcons.vue"))
const Mobile = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/mobileIcons.vue"))
const Multimedia = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/multimediaIcons.vue"))
const Payment = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/paymentIcons.vue"))
const Person = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/personIcons.vue"))
const Search = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/searchIcons.vue"))
const Social = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/socialIcons.vue"))
const Sport = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/sportIcons.vue"))
const Text = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/textIcons.vue"))
const Transport = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/transportIcons.vue"))
const Travel = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/travelIcons.vue"))
const Weather = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/weatherIcons.vue"))
const Web = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/webIcons.vue"))

import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
function icon_bar(icon: string) {
    select_icon.value.class = 'icofont icofont-' + icon;
    select_icon.value.tag = '<i class="icofont icofont-' + icon + '"></i>';
    icon_bar_status.value = true;
}
function close_icon_bar() {
    icon_bar_status.value = false;
}
function copy_icon() {
    toast.info('Code Copied to clipboard! ', {
        hideProgressBar: true, autoClose: 2000, theme: 'colored', position: 'bottom-right',
    });
    navigator.clipboard.writeText(select_icon.value.tag);
    document.execCommand('copy');
}
</script>